const cardItems = [
  {
    title: '《暗潮》',
    subtitle: '悬疑 / 2026',
    desc: '一桩离奇命案牵扯出尘封多年的秘密，真相远比想象中更加黑暗。豆瓣8.7分年度悬疑佳作。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20city%20street%20at%20night%20with%20mysterious%20figure%20silhouette%2C%20warm%20streetlamp%20glow%2C%20noir%20cinematic%20mood%2C%20film%20poster%20style%2C%20no%20text&width=400&height=250&seq=card-chunse-01&orientation=landscape',
    rating: '8.7',
    tag: '热播',
  },
  {
    title: '《山河纪》第三季',
    subtitle: '古装 / 2026',
    desc: '波澜壮阔的历史画卷再度展开，原班人马倾情演绎，制作全面升级。国剧新标杆。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20silhouette%20against%20golden%20sunset%20sky%2C%20warm%20atmospheric%20lighting%2C%20traditional%20rooftops%2C%20epic%20historical%20drama%20poster%20style%2C%20no%20text&width=400&height=250&seq=card-chunse-02&orientation=landscape',
    rating: '9.1',
    tag: '爆款',
  },
  {
    title: '《星际迷航：新纪元》',
    subtitle: '科幻 / 2026',
    desc: '人类探索未知星系，面对终极考验。耗资3亿的视觉盛宴，国产科幻电影新高度。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20against%20colorful%20nebula%20background%2C%20warm%20orange%20cosmic%20glow%2C%20sci-fi%20movie%20poster%20aesthetic%2C%20cinematic%20composition%2C%20no%20text&width=400&height=250&seq=card-chunse-03&orientation=landscape',
    rating: '8.4',
    tag: '新上',
  },
  {
    title: '《青春不散场》',
    subtitle: '喜剧 / 2026',
    desc: '一群高中好友十年后再聚首，笑中带泪的青春回忆。轻松温暖，治愈力满分。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20school%20playground%20at%20golden%20hour%2C%20nostalgic%20youth%20atmosphere%2C%20soft%20focus%2C%20coming-of-age%20film%20poster%20style%2C%20no%20text&width=400&height=250&seq=card-chunse-04&orientation=landscape',
    rating: '7.9',
    tag: '推荐',
  },
  {
    title: '《深海迷踪》',
    subtitle: '纪录 / 2026',
    desc: '历时三年深入全球七大海洋秘境，真实记录海洋奇观。豆瓣9.3高分纪录片。',
    image: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20with%20sunlight%20rays%20streaming%20through%20water%2C%20marine%20life%20silhouettes%2C%20mysterious%20underwater%20atmosphere%2C%20documentary%20film%20poster%20style%2C%20no%20text&width=400&height=250&seq=card-chunse-05&orientation=landscape',
    rating: '9.3',
    tag: '高分',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            热播推荐
          </h2>
          <p className="text-sm text-foreground-400">大家都在看的精选内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 2).map((item, i) => (
            <div
              key={i}
              className="group bg-background-200/40 rounded-lg border border-background-300/20 overflow-hidden cursor-pointer hover:border-primary-500/30 transition-all"
            >
              <div className="relative aspect-[16/10] bg-background-300/30 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-background-950/70 text-xs text-primary-400 font-bold backdrop-blur-sm">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <div className="text-xs text-foreground-500 mt-0.5 mb-2">{item.subtitle}</div>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}

          {cardItems.slice(2).map((item, i) => (
            <div
              key={i + 2}
              className="group bg-background-200/40 rounded-lg border border-background-300/20 overflow-hidden cursor-pointer hover:border-primary-500/30 transition-all"
            >
              <div className="relative aspect-[16/10] bg-background-300/30 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-background-950/70 text-xs text-primary-400 font-bold backdrop-blur-sm">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <div className="text-xs text-foreground-500 mt-0.5 mb-2">{item.subtitle}</div>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}